import './style.css';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import gsap from "gsap";

export const zonasMaterials = [];
let targetActive = 1.0;
let currentActive = 1.0;

export const setHalosActive = (isActive) => {
    targetActive = isActive ? 1.0 : 0.0;
};

// Animación simple de opacidad en GSAP
gsap.ticker.add((time) => {
    currentActive += (targetActive - currentActive) * 0.05;
    
    // Pulso suave
    const pulse = 0.6 + Math.sin(time * 2.0) * 0.4;
    
    zonasMaterials.forEach(mat => {
        mat.opacity = currentActive * pulse * 0.5; // Max 50% transparente
    });
});

export const loadModelZonas = (scene, loadingManager) => {
    return new Promise((resolve, reject) => {
        const loader = new GLTFLoader(loadingManager);
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        loader.setDRACOLoader(dracoLoader);

        loader.load(
            "static/models/caminar-zonas.glb",
            (gltf) => {
                const cZonas = gltf.scene;
                cZonas.position.set(-2, 3, 5); // Ajustar la posición del modelo
                cZonas.scale.set(1, 1, 1);
                cZonas.rotation.y = Math.PI / 2;

                cZonas.traverse((child) => {
                    if (child.isMesh) {
                        child.receiveShadow = false;
                        
                        // Un material básico, inafectable por sombras, con color sutil gris claro/blanco
                        const transparentMat = new THREE.MeshBasicMaterial({
                            color: 0xdddddd, // Gris muy claro casi blanco
                            transparent: true,
                            opacity: 0.35,
                            depthWrite: false,
                            blending: THREE.NormalBlending
                        });
                        
                        child.material = transparentMat;
                        zonasMaterials.push(transparentMat);
                        
                        child.visible = true;
                    }
                });

                scene.add(cZonas);
                
                // Resolver la promesa
                resolve();
            },
            undefined,
            (error) => reject(error)
        );
    });
};
